import {useEffect, useState} from "react";

const ToggleSwitch = ({value, onChange}) => {
    const [isChecked, setIsChecked] = useState(value);

    useEffect(() => {
        setIsChecked(value); // Sync state with prop when it changes
    }, [value]);

    const handleToggleChange = (event) => {
        const newChecked = event.target.checked; // Get the new checked state
        setIsChecked(newChecked); // Update local state
        onChange(newChecked); // Pass the new state to the parent
    };

    return (
        <label className="relative inline-block w-16 h-8">
            <input
                type="checkbox"
                checked={isChecked}
                onChange={handleToggleChange}
                className="opacity-0 w-0 h-0"
            />
            <span
                className={`slider block absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition-colors duration-300 ${
                    isChecked ? 'bg-blue-500' : 'bg-gray-300'
                }`}
            />
            <span
                className={`absolute left-1 bottom-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 transform ${
                    isChecked ? 'translate-x-8' : 'translate-x-0'
                }`}
            />
        </label>
    );
};

export default ToggleSwitch;
